import { Component, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-carouselimage',
  templateUrl: './carouselimage.component.html',
  styleUrls: ['./carouselimage.component.scss']
})
export class CarouselimageComponent implements OnInit {
  @Input() text = '';
  @Input() src = '';

  constructor() { }

  ngOnInit(): void {
  }

}
